// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"77":"health","418":"addschedules","836":"import"}[chunkId] || chunkId) + "." + {"77":"07443d3c","418":"cc9997ea","470":"2e567a17","836":"8c72052c"}[chunkId] + ".js";
};